import React from 'react';
import PropTypes from 'prop-types';
import InViewObserver from 'components/InViewObserver';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Morebtn from '../../../../../components_v2/mobile/Morebtn';
import ReadAlsoWidgetLinks from './ReadAlsoWidgetLinks';

class ReadAlsoWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    let showMore = false;
    if (
      props.data &&
      Array.isArray(props.data) &&
      props.numberOfArticles &&
      props.data.length > props.numberOfArticles + 1
    ) {
      showMore = true;
    }
    this.state = {
      showMore,
    };
  }

  loadMoreHandler = () => {
    this.setState({ showMore: false });
  };

  viewGaFunc = () => {
    if (
      this.props.data &&
      Array.isArray(this.props.data) &&
      this.props.data.length > 0
    ) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: 'articleshow_inline_read_also',
        category: 'edit_filed',
        story_no: this.props.data.length,
      });
    }
  };

  render() {
    const { moreText, numberOfArticles = 4 } = this.props;
    const s = this.props.styleObj;

    let readMoreGA = `MTF_read_also|click|`;
    if (this.props.gaCategory) {
      readMoreGA = `${this.props.gaCategory}|click|readAlso`;
    }

    let dataToRender = this.props.data;
    if (
      Array.isArray(dataToRender) &&
      this.props.limitReadAlsoLinks &&
      dataToRender.length > this.props.limitReadAlsoLinks
    ) {
      dataToRender = dataToRender.slice(0, this.props.limitReadAlsoLinks);
    }

    return (
      <InViewObserver
        inViewCallback={() => {
          this.viewGaFunc();
        }}
      >
        <div
          data-type="embedgroup"
          className={`${s.readalso} ${
            this.state.showMore && this.props.isWapView ? s.showMore : ''
          } ${this.props.isTerminatingReadAlso ? s.readalso_last : ''}`}
        >
          <div className={s.heading}>
            <i />
            <span>Read Also</span>
          </div>
          {dataToRender &&
            Array.isArray(dataToRender) &&
            dataToRender.map((item, index) => (
              <ReadAlsoWidgetLinks
                item={item}
                readMoreGA={readMoreGA}
                index={index}
                styleObj={s}
                isWapView={this.props.isWapView}
                numberOfArticles={numberOfArticles}
                showMore={this.state.showMore}
                countReadAlso={this.props.countReadAlso}
                isfromEtimes={this.props.isfromEtimes}
                ga4Object={this.props.ga4Object}
              />
            ))}

          {this.props.isWapView &&
            this.state.showMore && (
              <div className={s.rmBtnWrap}>
                <Morebtn
                  onClick={this.loadMoreHandler}
                  absoluteMoreText={moreText}
                  isNoLink
                  linkData={{
                    gaAction: 'Click',
                    gaLabel: 'Read-also_More-Stories',
                  }}
                />
              </div>
            )}
        </div>
      </InViewObserver>
    );
  }
}
ReadAlsoWidget.propTypes = {
  data: PropTypes.array,
  isWapView: PropTypes.bool,
  styleObj: PropTypes.string.isRequired,
  gaCategory: PropTypes.string,
  numberOfArticles: PropTypes.number,
  moreText: PropTypes.string,
  isfromEtimes: PropTypes.bool,
  countReadAlso: PropTypes.string,
  isTerminatingReadAlso: PropTypes.bool,
  ga4Object: PropTypes.shape({}),
  limitReadAlsoLinks: PropTypes.number,
};

ReadAlsoWidget.defaultProps = {
  data: [],
  isWapView: false,
  gaCategory: '',
  numberOfArticles: 4,
  moreText: '',
  isfromEtimes: false,
  countReadAlso: '',
  isTerminatingReadAlso: false,
  ga4Object: undefined,
  limitReadAlsoLinks: undefined,
};

export default ReadAlsoWidget;
